module.exports = __webpack_public_path__ + "static/media/clearbit-home.1aa12bfa.jpg";